import type { App } from 'vue';
import { createPinia } from 'pinia';
export function hostPinia({ vueApp }: { vueApp: App }): void {
  vueApp.use(createPinia());
}
